if (!customElements.get("carousel-section-slider")) {
  class CarouselSectionSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector(".blaze-slider");
    }

    connectedCallback() {

      new BlazeSlider(this.slider, {
        all: {
          loop: true,
          enableAutoplay: true,
          stopAutoplayOnInteraction: false,
          autoplayInterval: 10000,
          transitionDuration: 1000,
          slidesToShow: 1,
        },
      });
    }

    disconnectedCallback() {
    }
  }

  customElements.define("carousel-section-slider", CarouselSectionSlider);
}
